import axios from 'axios';
import CONFIGS from '../configs';

  // Get all projects
  export const getProjects = () => {
    return axios.get(`${process.env.REACT_APP_API_URL}/api/k3project`);
  }

  // Get single project
  export const getProject = (id) => {
    return axios.get(`${process.env.REACT_APP_API_URL}/api/k3project/${id}`);
  }

  // Create project
  export const createProject = (projectData) => {
    return axios.post(`${process.env.REACT_APP_API_URL}/api/k3project`, projectData);
  }

  // Update project
  export const updateProject = (id, projectData) => {
    return axios.put(`${process.env.REACT_APP_API_URL}/api/k3project/${id}`, projectData);
  }

  // Delete project
  export const deleteProject = (id) => {
    return axios.delete(`${process.env.REACT_APP_API_URL}/api/k3project/${id}`);
  }

  export const projectService = {
    getProjects,
    getProject,
    createProject,
    updateProject,
    deleteProject
  }

